import { render, staticRenderFns } from "./UsageChargeUpgradeModal.vue?vue&type=template&id=296b2f9b&scoped=true"
import script from "./UsageChargeUpgradeModal.vue?vue&type=script&lang=js"
export * from "./UsageChargeUpgradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b2f9b",
  null
  
)

export default component.exports